import React, { useEffect, useState } from "react";
import BoxShadow from "../SvgIcons/LoginIcons/BoxShadow";
import LogoBG from "../SvgIcons/LoginIcons/LogoBG";
import Button from "../Button/Button";
import { Link } from "react-router-dom";
import { FormProvider, useForm } from "react-hook-form";
import LangChange from "../LangChange/LangChange";
import Input from "../Input/Input";
import ShotclassNewLogo from "../SvgIcons/CommonIcons/ShotclassNewLogo";
import { yupResolver } from "@hookform/resolvers/yup";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import {
  loginSchema,
  preloginSchema,
} from "../../../utils/preloginAndLoginSchema";
import {
  forgotPasswordActionHandler,
  isUserActiveActionHandler,
  loginActionHandler2,
  preLoginActionHandler,
} from "../../../store/actions/actionHandlers/loginActionHandler";
import classes from "./LoginLayout.module.scss";
import RequestPasswordModal from "../../Login/RequestPasswordModal/RequestPasswordModal";
import { errorTypes } from "../../../utils/errorTypes";
import { setErrorHandler } from "../../../store/actions/actionHandlers/errorActionHandler";
import getTenantName from "../../../utils/getTenantName";
import Shotclasses_General_Logo from "../../../assets/images/Common/Shotclasses_General_Logo.png";
import { decodeToken } from "../../../utils/decodeToken";
import {
  domains,
  isMatchingDomain,
} from "../../../utils/ltimSSOLoginCondition";

const LoginLayout = ({ prelogin = false }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const loginState = useSelector((state) => state.loginReducer);
  const { preLoginLoading, loginLoading } = loginState;

  const [requestPassword, setRequestPassword] = useState(false);

  const schema = prelogin ? preloginSchema : loginSchema;
  const methods = useForm({
    resolver: yupResolver(schema),
  });
  const {
    handleSubmit,
    formState: { errors },
    setFocus,
    setValue,
    getValues,
  } = methods;

  const formData = {
    name1: prelogin ? "OrganizationID" : "UserName",
    label1: prelogin ? "Organization ID" : "User Name",
    type1: prelogin ? "text" : "text",
    placeHolder1: prelogin
      ? "Please enter your organization ID"
      : "Please enter your user name",
    name2: prelogin ? "UserName" : "Password",
    label2: prelogin ? "User Name" : "Password",
    type2: prelogin ? "text" : "password",
    placeHolder2: prelogin
      ? "Please enter your user name"
      : "Please enter your password",
  };

  const themeData = JSON.parse(localStorage.getItem("themeData"));
  const color = themeData?.CustomData?.PrimaryColor1;
  const logo = themeData?.CustomData?.LogoImage;
  const buttonLabel = prelogin ? "Proceed" : "Sign In";
  const heading = prelogin ? "Login" : "Credentials";
  let userName = localStorage.getItem("userName") || getValues(formData.name1);
  const tenantName = getTenantName(dispatch, location);
  const userData = decodeToken(localStorage.getItem("token"));
  const usernameFormToken = userData?.unique_name;
  // Set only when arriving from a hybrid-custom tenant's prelogin submit
  const hybridUserName = location.state?.hybridUserName;
  // Set only when arriving from a hybrid-SAML tenant's automatic redirect to prelogin
  const isHybridPrelogin = prelogin && !!location.state?.fromHybridTenant;

  useEffect(() => {
    setFocus(formData.name1);
    if (isHybridPrelogin) {
      const savedTenantName = localStorage.getItem("tenantName");
      if (savedTenantName) setValue(formData.name1, savedTenantName);
    }
    if (isMatchingDomain(domains) && usernameFormToken)
      setValue(formData.name2, usernameFormToken);
    if (!prelogin) {
      setValue(formData.name1, hybridUserName || userName);
      setFocus(formData.name2);
    }
  }, [
    setFocus,
    setValue,
    formData.name1,
    formData.name2,
    prelogin,
    userName,
    hybridUserName,
  ]);

  const handleRequestPassword = () => {
    if (
      tenantName === "" ||
      tenantName === undefined ||
      tenantName === null ||
      userName === "" ||
      userName === undefined ||
      userName === null
    ) {
      dispatch(
        setErrorHandler(
          errorTypes.WARN,
          "Please enter organization Id and username again"
        )
      );
      handleRequestPasswordModal();
    } else {
      dispatch(forgotPasswordActionHandler(userName, tenantName)).then(() => {
        handleRequestPasswordModal();
      });
    }
  };
  const handleRequestPasswordModal = () => {
    dispatch(isUserActiveActionHandler(userName, tenantName)).then(
      (response) => {
        if (response.data == false) {
          dispatch(setErrorHandler(errorTypes.FAIL, "UserId is inactive"));
        } else {
          setRequestPassword(!requestPassword);
        }
      }
    );
  };

  const onSubmit = (data) => {
    if (prelogin) {
      dispatch(
        preLoginActionHandler(
          data.OrganizationID,
          data.UserName,
          navigate,
          true,
          false,
          isHybridPrelogin
        )
      );
    } else {
      dispatch(loginActionHandler2(data.UserName, data.Password, navigate));
    }
  };

  const onKeyDown = (e) => {
    if (e?.key === "enter") onSubmit();
  };

  return (
    <div className={classes.loginLayout}>
      <div className={classes.loginLayout__container}>
        <div className={classes.loginLayout__container__main}>
          <div
            className={classes.loginLayout__container__main__left}
            style={{ backgroundColor: !prelogin ? color : "#f3f3f3" }}
          >
            {!prelogin ? (
              <></>
            ) : (
              <div
                className={classes.loginLayout__container__main__left__logoBG}
              >
                <LogoBG />
              </div>
            )}
            <div className={classes.loginLayout__container__main__left__logo}>
              {/* {!prelogin ? <img src={logo} alt="logo" /> : <ShotclassNewLogo />} */}
              {!prelogin ? (
                <img src={logo} alt="logo" />
              ) : (
                <img
                  src={Shotclasses_General_Logo}
                  alt="Shotclasses Default Logo"
                  style={{ width: "20rem" }}
                />
              )}
            </div>
            <div
              className={classes.loginLayout__container__main__left__footer}
              style={{ color: !prelogin ? "#fff" : "#6b6b6b" }}
            >
              Powered by Shotclasses, LTM 2016-
              {new Date().getFullYear()}
            </div>
          </div>
          <div className={classes.loginLayout__container__main__right}>
            {!prelogin && (
              <div
                className={
                  classes.loginLayout__container__main__right__langChange
                }
              >
                <LangChange right={-20} />
              </div>
            )}
            <FormProvider {...methods}>
              <form
                onSubmit={handleSubmit(onSubmit)}
                className={classes.loginLayout__container__main__right__form}
                autoComplete="off"
              >
                <div
                  className={
                    classes.loginLayout__container__main__right__form__header
                  }
                  style={{
                    color: !prelogin ? color : "#404040",
                    borderBottom: `0.3rem solid ${
                      !prelogin ? color : "#404040"
                    }`,
                  }}
                >
                  {heading}
                </div>
                <div
                  className={
                    classes.loginLayout__container__main__right__form__inputs
                  }
                >
                  <Input
                    label={formData.label1}
                    name={formData.name1}
                    placeholder={formData.placeHolder1}
                    type={formData.type1}
                    error={errors[formData.name1]?.message}
                    labelColor="light"
                    width={"28"}
                    height={"4.6"}
                    disabled={
                      prelogin
                        ? isHybridPrelogin
                          ? true
                          : preLoginLoading
                        : hybridUserName
                        ? true
                        : isMatchingDomain(domains) && usernameFormToken
                        ? true
                        : loginLoading
                    }
                    autoComplete="off"
                    onKeyDown={onKeyDown}
                  />
                  <Input
                    label={formData.label2}
                    name={formData.name2}
                    placeholder={formData.placeHolder2}
                    type={formData.type2}
                    error={errors[formData.name2]?.message}
                    labelColor="light"
                    width={"28"}
                    height={"4.6"}
                    disabled={
                      prelogin && !usernameFormToken
                        ? preLoginLoading
                        : usernameFormToken && isMatchingDomain(domains)
                        ? true
                        : loginLoading
                    }
                    autoComplete="off"
                    onKeyDown={onKeyDown}
                  />
                </div>
                <div
                  className={
                    classes.loginLayout__container__main__right__form__button
                  }
                >
                  <Button
                    label={buttonLabel}
                    type="submit"
                    backgroundColor={
                      preLoginLoading || loginLoading
                        ? undefined
                        : !prelogin
                        ? color
                        : "#D31B61"
                    }
                    borderRadius={"0.6"}
                    color={preLoginLoading || loginLoading ? undefined : "#fff"}
                    width={"17.8"}
                    height={"4.4"}
                    loading={prelogin ? preLoginLoading : loginLoading}
                  />
                </div>
                {!prelogin ? (
                  <div
                    className={
                      classes.loginLayout__container__main__right__form__links
                    }
                  >
                    <div
                      className={
                        classes.loginLayout__container__main__right__form__links__link
                      }
                      onClick={handleRequestPasswordModal}
                    >
                      Request New Password
                    </div>
                    <Link
                      to="/"
                      className={
                        classes.loginLayout__container__main__right__form__links__link
                      }
                    >
                      Change Organization ID
                    </Link>
                  </div>
                ) : (
                  <></>
                )}
              </form>
            </FormProvider>
          </div>
        </div>
        <div className={classes.loginLayout__container__boxShadow}>
          <BoxShadow />
        </div>
      </div>
      <RequestPasswordModal
        handleRequestPassword={handleRequestPassword}
        handleRequestPasswordModal={handleRequestPasswordModal}
        requestPassword={requestPassword}
      />
    </div>
  );
};

export default LoginLayout;
